module.exports = __webpack_public_path__ + "static/media/step-2.c4ff9633.png";